import { InfoCircleOutlined } from '@ant-design/icons';
import { Alert } from 'antd';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledInfoNotice = styled(Alert).withConfig({
  displayName: "info-noticecomponent__StyledInfoNotice",
  componentId: "sc-1j4r1oq-0"
})(["align-items:flex-start;gap:11px;padding:13px 15px;border:1px solid #dce8ff;border-radius:10px;background:#f2f7ff;.ant-alert-icon{flex:0 0 22px;margin:0;color:#245eff;font-size:20px;line-height:22px;}.ant-alert-content{min-width:0;}.ant-alert-message{margin-bottom:2px;color:#245eff;font-size:14px;font-weight:600;line-height:22px;}.ant-alert-description{color:#242833;font-size:14px;line-height:22px;overflow-wrap:anywhere;}"]);
export var InfoNotice = function InfoNotice(_ref) {
  var title = _ref.title,
      description = _ref.description,
      className = _ref.className,
      style = _ref.style;
  return /*#__PURE__*/_jsx(StyledInfoNotice, {
    type: "info",
    showIcon: true,
    icon: /*#__PURE__*/_jsx(InfoCircleOutlined, {}),
    message: title,
    description: description,
    className: className,
    style: style
  });
};